/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { type ReactNode, useState } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const startStyles = xcss({
	opacity: '0',
	transform: 'translateY(10vh)',
	transition:
		'opacity 0.4s cubic-bezier(0.4, 0.14, 0.3, 1), transform 0.4s cubic-bezier(0.4, 0.14, 0.3, 1)',
	willChange: 'opacity transform',
	'@media (prefers-reduced-motion: reduce)': {
		opacity: '1',
		transform: 'none',
		transition: 'none',
	},
});

const endStyles = xcss({
	opacity: '1',
	transform: 'none',
});

export const SlideAndFadeIn = ({
	delay = '0ms',
	children,
}: {
	delay?: string;
	children: ReactNode;
}) => {
	const [isVisible, setVisible] = React.useState(false);
	const [isFirstView, setIsFirstView] = useState(true);
	const ref = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		if (!ref.current) {
			return;
		}

		const observerRef = ref.current;

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!isFirstView) {
					return;
				}

				if (entry.isIntersecting) {
					setVisible(true);
					setIsFirstView(false);
				}
			});
		});

		observer.observe(observerRef);

		return () => observer.unobserve(observerRef);
	}, [isFirstView]);

	return (
		<Box
			style={{ transitionDelay: delay }}
			ref={ref}
			as="div"
			xcss={[startStyles, isVisible && endStyles]}
		>
			{children}
		</Box>
	);
};
